// removed by extract-text-webpack-plugin
module.exports = {"storeWrap":"qempo_Store_storeWrap-7RiTFWX","landing":"qempo_Store_landing-1c0Oy0K","rowWrap":"qempo_Store_rowWrap-2ZWKjMf","whyBuyFrom":"qempo_Store_whyBuyFrom-kPc1bxm","banner":"qempo_Store_banner-ngsj0fW","modalLoading":"qempo_Store_modalLoading-mvgzcYw"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/store/components/Store.scss
// module id = 2048
// module chunks = 0